Pixlee.module('Utilities', function(Utilities, App, Backbone, Marionette, $) {
    var _this = this,
        API;

    API = {
        tries: 0,
        queueArray: [],
        acceptCookiePolicy: false,
        numPhotos: null,
        pendingWidgetVisible: false,
        checkQueue: function() {
            var _this = this;
            if (!this.getDistinctUserHash()) {
                return false;
            }
            if (gon.requireCookieConsent && !this.acceptCookiePolicy) {
                // It's possible that the cookie policy gets denied after
                // this queue has started since the message is async.
                return;
            }

            var asynchKeen = function(ob) {
                if (!_this.KeenClient && typeof Keen != 'undefined') {
                    Keen.ready(function() {
                        _this.KeenClient = new Keen({
                            projectId: keen_project_id,
                            writeKey: keen_write_key,
                            host: gon.global.env.startsWith('staging') ? 'tinyrick.stag.pixlee.io' : 'tinyrick.pixlee.com'
                        });
                        _this.KeenClient.recordEvent(ob.event, ob.obj);
                    });
                } else {
                    _this.KeenClient.recordEvent(ob.event, ob.obj);
                }
            };

            _.each(this.queueArray, function(ob) {
                //if this user has a unique attribution window, override the default 30
                ob.obj.attribution_window = gon.current_account.extra_fields.attribution_window || 30;

                if (!ob.obj.distinct_user_hash) {
                    ob.obj.distinct_user_hash = _this.getDistinctUserHash();
                }
                if (ob.cookieEvent) {
                    _this.sendDataToParent(ob.obj, ob.cookieEvent);
                }
                if (gon.fingerprint && gon.fingerprint !== 'none') {
                    ob.obj.fingerprint = gon.fingerprint;
                }
                if (gon.region_id) {
                    ob.obj.region_id = gon.region_id;
                }
                _this.addKeenData(ob.obj);
                asynchKeen(ob);
            });
            this.queueArray = [];
        },
        getCookie: function(cname) {
            return this._getCookieHelper(cname) || this._getCookieHelper(cname + '_legacy');
        },

        _getCookieHelper: function(cname) {
            var name = cname + "=";
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        },
        addKeenData: function(obj) {
            var addons = [];

            addons.push({
                name: 'keen:ip_to_geo',
                input: {
                    ip: 'ip_address'
                },
                output: 'ip_geo_info'
            });
            obj.ip_address = gon.remote_ip;

            addons.push({
                name: 'keen:ua_parser',
                input: {
                    ua_string: 'user_agent'
                },
                output: 'parsed_user_agent'
            });
            obj.user_agent = navigator.userAgent;

            addons.push({
                name: 'keen:url_parser',
                input: {
                    url: 'page_url'
                },
                output: 'parsed_page_url'
            });
            obj.page_url = document.location.href;

            addons.push({
                name: 'keen:referrer_parser',
                input: {
                    referrer_url: 'referrer_url',
                    page_url: 'page_url'
                },
                output: 'referrer_info'
            });
            obj.referrer_url = document.referrer;
            obj.page_url = document.location.href;

            obj.keen = {
                addons: addons
            };
        },
        queueEvents: function() {
            var _this = this;
            setTimeout(function() {
                if (_this.queueArray.length > 0 && (!gon.requireCookieConsent || _this.acceptCookiePolicy)) {
                    _this.checkQueue();
                }
                _this.queueEvents();
            }, 200);
        },
        sendDataToParent: function(obj, name) {
            var msg = {
                name: name,
                type: 'action',
                source: 'widget',
                destination: 'parent',
                data: obj
            };

            try {
                window.parent.postMessage(JSON.stringify(msg), '*');
            } catch (e) {
                if (document.referrer.indexOf('converse.com') === -1 && navigator.userAgent.indexOf('Opera') === -1) {
                    console.warn(e);
                }
            }

        },
        OpenedPhotowall: function(photos, mosiac) {
            var obj = this.defaultProperties();
            this.photos = photos;
            obj.photos = this.convertToStrings(photos);
            obj.num_photos = photos ? photos.length : 0;
            if (mosiac) {
                obj.mosaic = true;
                this.widget = 'Mosaic';
            } else {
                this.widget = 'Photowall';
            }
            obj.widget = this.widget;
            gon.widget = this.widget;
            if (gon.pixlee_start) {
                obj.loadTime = this.getPerf() - gon.pixlee_start;
            }
            this.openedWidget(obj, this.widget);
        },
        OpenedTap2Shop: function(photos) {
            var obj = this.defaultProperties();
            this.photos = photos;
            this.widget = 'Tap2Shop';
            obj.photos = this.convertToStrings(photos);
            obj.num_photos = photos ? photos.length : 0;
            obj.widget = this.widget;
            gon.widget = this.widget;
            if (gon.pixlee_start) {
                obj.loadTime = this.getPerf() - gon.pixlee_start;
            }
            this.openedWidget(obj, this.widget);
        },
        OpenedSingle: function(album_photo) {
            var obj = this.defaultProperties();
            obj.photos = String(album_photo);
            obj.num_photos = 1;
            this.widget = 'Single';
            obj.widget = this.widget;
            gon.widget = this.widget;
            if (gon.pixlee_start) {
                obj.loadTime = this.getPerf() - gon.pixlee_start;
            }
            this.openedWidget(obj, this.widget);
        },
        kpiEvent: function(event) {
            var obj = this.defaultProperties();
            obj.widget = this.widget;
            obj.kpiEvent = event;
            var ob = {
                obj: obj,
                event: 'KPI Event'
            };
            this.queueArray.push(ob);
        },
        OpenedSlideshow: function(photos) {
            var obj = this.defaultProperties();
            obj.photos = this.convertToStrings(photos);
            obj.num_photos = 1;
            this.widget = 'Slideshow';
            obj.widget = this.widget;
            gon.widget = this.widget;
            if (gon.pixlee_start) {
                obj.loadTime = this.getPerf() - gon.pixlee_start;
            }
            this.openedWidget(obj, this.widget);
        },
        OpenedCarousel: function(photos, options) {
            var obj = this.defaultProperties();
            obj.photos = this.convertToStrings(photos);
            obj.num_photos = photos ? photos.length : 0;
            this.widget = 'Carousel';
            obj.carousel_options = options;
            obj.widget = this.widget;
            gon.widget = this.widget;
            if (gon.pixlee_start) {
                obj.loadTime = this.getPerf() - gon.pixlee_start;
            }
            this.openedWidget(obj, this.widget);
        },
        OpenedHorizontal: function(photos, coverflow) {
            var obj = this.defaultProperties();
            obj.photos = this.convertToStrings(photos);
            obj.num_photos = photos ? photos.length : 0;
            if (coverflow) {
                obj.coverflow = true;
                this.widget = 'Coverflow';
            } else {
                this.widget = 'Horizontal';
            }
            obj.widget = this.widget;
            gon.widget = this.widget;
            if (gon.pixlee_start) {
                obj.loadTime = this.getPerf() - gon.pixlee_start;
            }
            this.openedWidget(obj, this.widget);
        },
        OpenedVertical: function(photos) {
            var obj = this.defaultProperties();
            obj.photos = this.convertToStrings(photos);
            obj.num_photos = photos ? photos.length : 0;
            this.widget = 'Vertical';
            obj.widget = this.widget;
            gon.widget = this.widget;
            if (gon.pixlee_start) {
                obj.loadTime = this.getPerf() - gon.pixlee_start;
            }
            this.openedWidget(obj, this.widget);
        },
        getPerf: function() {
            if (typeof performance != 'undefined' && typeof performance.now != 'undefined' && typeof gon != 'undefined') {
                return performance.now();
            } else if (typeof Date != 'undefined' && typeof Date.now != 'undefined' && typeof gon != 'undefined') {
                return Date.now();
            }
        },
        LoadMore: function(photos, mosiac) {
            var obj = this.defaultProperties();
            var _photos = _.difference(photos, this.photos);
            this.photos = photos;
            obj.photos = this.convertToStrings(_photos);
            obj.num_photos = _photos ? _photos.length : 0;
            if (mosiac) {
                obj.mosaic = true;
                this.widget = 'Mosaic';
            } else {
                this.widget = 'Photowall';
            }
            //add interacted
            obj.subcollection = 'Load More';
            var interacted_ob = {
                obj: obj,
                cookieEvent: 'pixlee:interacted',
                event: 'Interacted'
            };

            this.queueArray.push(interacted_ob);
        },
        ActionLinkClicked: function(album_photo_id, action_link_url) {
            var obj = this.defaultProperties();
            obj.album_photo_id = album_photo_id;
            obj.action_link_url = action_link_url;
            if (gon.type === 'tap2shop') {
                obj.tap2shop = true;
            }
            //add interacted!
            obj.subcollection = 'Action Clicked';
            var interacted_ob = {
                obj: obj,
                cookieEvent: 'pixlee:interacted',
                event: 'Interacted'
            };

            this.queueArray.push(interacted_ob);
        },
        OpenedPhoto: function(album_photo_id, currentPage, direct_click) {
            var obj = this.defaultProperties();
            obj.album_photo_id = album_photo_id;
            obj.currentDistilleryPage = currentPage;
            obj.direct_click = direct_click;
            if (gon.type === 'tap2shop') {
                obj.tap2shop = true;
            }
            obj.subcollection = 'Opened Lightbox';
            //add interacted
            var interacted_ob = {
                obj: obj,
                cookieEvent: 'pixlee:opened:photo',
                event: 'Interacted'
            };
            this.queueArray.push(interacted_ob);
        },
        PhotoAdded: function(data) {
            this.queueArray.push({
                obj: _.extend(this.defaultProperties(), data),
                event: 'Photo Added'
            });
        },
        NavLeft: function(photos) {
            var obj = this.defaultProperties();
            obj.widget_config = this.defaultWidgetConfig();
            obj.photos = this.convertToStrings(photos);
            obj.widget = this.widget;
            var ob = {
                obj: obj,
                event: 'Nav Left',
                cookieEvent: 'pixlee:interacted'
            };
            //dont track this for now
            //this.queueArray.push(ob);
        },
        NavRight: function(photos) {
            var obj = this.defaultProperties();
            obj.widget_config = this.defaultWidgetConfig();
            obj.photos = this.convertToStrings(photos);
            obj.num_photos = photos ? photos.length : 0;
            obj.widget = this.widget;

            //add interacted
            obj.subcollection = 'Nav Right';
            var interacted_ob = {
                obj: obj,
                cookieEvent: 'pixlee:interacted',
                event: 'Interacted'
            };
            this.queueArray.push(interacted_ob);
        },
        PhotoShared: function(album_photo_id, platform) {
            var obj = this.defaultProperties();
            obj.widget = this.widget;
            obj.album_photo_id = album_photo_id;
            obj.platform = platform;

            //add interacted
            obj.subcollection = 'Photo Shared';
            var interacted_ob = {
                obj: obj,
                event: 'Interacted'
            };
            this.queueArray.push(interacted_ob);
        },
        StandaloneClickThrough: function(ev) {
            var obj = this.defaultProperties();
            obj.widget = this.widget;
            obj.type = ev;

            obj.brand_url = gon.display_options.standaloneOptions.brandURL;
            obj.is_mobile = gon.isMobile || false;
            obj.is_tablet = gon.isTablet || false;

            var ob = {
                obj: obj,
                event: 'Click Through'
            };
            this.queueArray.push(ob);
        },
        WidgetVisible: function() {
            var obj = this.defaultProperties();
            obj.widget_config = this.defaultWidgetConfig();

            var ob = {
                obj: obj,
                event: 'Widget Visible'
            };

            this.queueArray.push(ob);
        },
        defaultProperties: function() {
            var _this = this;
            var albumId = gon.current_photo ? gon.current_photo.album_id : gon.current_album.id;
            var publicationId = gon.current_photo ? null : (gon.recipe.filter_sort_id || gon.publication_id);
            var parentUrlParam = this.getParameterByName('parent_url', document.location.href);
            var properties = {
                album_id: albumId,
                account_id: gon.current_account.id,
                publication_id: publicationId,
                distinct_user_hash: this.getDistinctUserHash(),
                sortType: gon.sortType,
                parentURL: parentUrlParam,
                baseParentURL: _.isTruthy(parentUrlParam) ? parentUrlParam.split(/[?#]/)[0] : null,
                displayed: this.isDisplayed(),
                widget_version: App.version,
                business_name: gon.current_account.business_name,
                account_type: gon.current_account.account_type
            };
            if (gon.current_album) {
                properties['album_type'] = gon.current_album.album_type;
            }
            if (gon.widget_id) {
                properties['widget_id'] = parseInt(gon.widget_id);
            }
            if (gon.widget_id_param) {
                properties['widget_id_param'] = parseInt(gon.widget_id_param);
            }
            if (gon.widget_type) {
                properties['widget_type'] = gon.widget_type;
            } else {
                properties['widget_type'] = 'simple';
            }
            if (gon.fingerprint) {
                properties['fingerprint'] = gon.fingerprint;
            }
            if (gon.experiment_id && gon.experiment_group) {
                properties['experiment_id'] = gon.experiment_id;
                properties['experiment_group'] = gon.experiment_group;
            }
            return properties;
        },
        defaultWidgetConfig: function() {
            var _this = this;
            var lightbox;
            var uploaderButton = $('#upload_now');
            var displayOptions = gon.display_options;
            var headerOptions = displayOptions.headerOptions;
            var interactiveWidgetOptions = displayOptions.interactiveWidgetOptions;
            var interactiveWidgetTrack;
            var albumFilters = gon.recipe ? this.extractActiveFilters(gon.recipe.filters) : null;
            var isUploaderVisible = uploaderButton ? uploaderButton.css('display') !== 'none' : false;

            if (displayOptions.showCallToAction) {
                lightbox = 'CTA';
            } else {
                lightbox = 'default';
            }

            if (interactiveWidgetOptions) {
                interactiveWidgetTrack = {
                    categories: interactiveWidgetOptions.categories,
                    location: interactiveWidgetOptions.location,
                    personalized: interactiveWidgetOptions.personalized,
                    months: interactiveWidgetOptions.seasons,
                    search: interactiveWidgetOptions.search,
                    sort: interactiveWidgetOptions.sort,
                    sortPopular: interactiveWidgetOptions.sortPopular,
                    sortPrice: interactiveWidgetOptions.sortPrice,
                    sortRecent: interactiveWidgetOptions.sortRecent,
                    widgetType: interactiveWidgetOptions.widgetType,
                    interactiveWidgetType: interactiveWidgetOptions.interactiveWidgetType,
                    numOfCategories: interactiveWidgetOptions.selectedCategories ? interactiveWidgetOptions.selectedCategories.length : 0,
                    selectedCategories: interactiveWidgetOptions.selectedCategories
                };
            }
            var properties = {
                interactiveWidgetOptions: interactiveWidgetTrack || false,
                interactive_social_hub: displayOptions.is_interactive || false,
                interactive_social_hub_type: interactiveWidgetOptions ? interactiveWidgetOptions.interactiveWidgetType : false,
                header_layout: headerOptions ? headerOptions.layout : false,
                uploader: isUploaderVisible,
                uploader_button_style: headerOptions ? headerOptions.button : false,
                lightbox: lightbox,
                theme: displayOptions.css_preset_filename || displayOptions.css_preset_filename_v2 || '',
                mobile_optimization: displayOptions.showViewport || false,
                load_priority: displayOptions.speedOptimization || false,
                album_filters: albumFilters,
                end_tile_uploader: headerOptions && headerOptions.end_tile_upload_button_background_showHide ? headerOptions.end_tile_upload_button_background_showHide : false
            };
            return properties;
        },
        defaultUserInfo: function() {
            // uncomment if we need more user data
            return {
                // timezone:(new Date()).getTimezoneOffset()/60,
                // pageon: window.location.pathname,
                // referrerf: document.referrer,
                // previousSites: history.length,
                // browserName: navigator.appName,
                // browserEngine: navigator.product,
                // browserVersion1a: navigator.appVersion,
                // browserVersion1b: navigator.userAgent,
                // browserLanguage: navigator.language,
                // browserOnline: navigator.onLine,
                // browserPlatform: navigator.platform,
                // javaEnabled: navigator.javaEnabled(),
                // dataCookiesEnabled: navigator.cookieEnabled,
                // sizeScreenW: screen.width,
                // sizeScreenH: screen.height,
                // sizeInW: window.innerWidth,
                // sizeInH: window.innerHeight,
                // sizeAvailW: screen.availWidth,
                // sizeAvailH: screen.availHeight,
                // scrColorDepth: screen.colorDepth,
                // scrPixelDepth: screen.pixelDepth,
                isMobile: gon.is_mobile || false
            };
        },
        extractActiveFilters: function(obj) {
            /*There are 3 types of filters: 'simple' (boolean/string), object and array. we want to keep the following:
                (1) All non-falsy 'simple' filters (i.e. true booleans and non empty strings)
                (2) All objects contain at least one array in them. We want objects where at least one of this has elements in it
                (3) All Arrays with length > 0
            */
            var result = {};

            //can't use _.filter because we need to preserve the key too not just the value
            _.each(obj, function(prop, key) {
                var success = false;

                if (Array.isArray(prop)) {
                    success = prop.length > 0;
                } else if (typeof prop === 'object') {
                    var arraySize = 0;

                    //sum the length of all subproperties (they are all strings or arrays) and return if total length > 0
                    _.each(prop, function(subProp) {
                        //check that it has a length just in case we add something other than a string or array later
                        arraySize += subProp.length ? subProp.length : 0;
                    });

                    success = arraySize > 0;
                } else {
                    success = !_.isFalsy(prop);
                }

                if (success) {
                    result[key] = prop;
                }
            });

            return result;
        },
        getDistinctUserHash: function() {
            if (typeof analytics !== 'undefined' && analytics.getAnonymousId) {
                return analytics.getAnonymousId();
            } else {
                var msg = {
                    name: 'pixlee:log:to:sentry',
                    type: 'action',
                    source: 'widget',
                    destination: 'parent',
                    data: {
                        messageText: 'Failed to retrieve DUH',
                        messageExtraFields: {
                            tags: {
                                source: 'widgets',
                                analytics: typeof analytics !== 'undefined',
                                file: 'analytics_events.js'
                            }
                        }
                    }
                };
                //window.parent.postMessage(JSON.stringify(msg), '*');
            }
        },
        isDisplayed: function() {
            if (this.getParameterByName('displayed') && this.getParameterByName('displayed') == 'none') {
                return 'none';
            } else {
                return 'block';
            }
        },
        getTime: function() {
            return Date.now();
        },
        convertToStrings: function(photos) {
            photos = _.map(photos, function(photo) {
                return photo + '';
            });
            return photos.join(',');
        },
        getCurrentItemIds: function(rel, collection) {
            var photos = [];
            collection.each(function(model) {
                if (model.get('album_photo_id')) {
                    photos.push(model.get('album_photo_id'));
                }
            });
            photos = photos.slice(rel.firstItem, rel.lastItem + 1);
            return photos;
        },
        getParameterByName: function(name, url) {
            name = name.replace(/[\[]/, '\\\[').replace(/[\]]/, '\\\]');
            var regex = new RegExp('[\\?&]' + name + '=([^&#]*)'),
                results = regex.exec(url);
            return results == null ? null : decodeURIComponent(results[1].replace(/\+/g, ' '));
        },
        openedWidget: function(obj, widget) {
            var _this = this;
            obj.widget = widget;
            obj.widget_config = this.defaultWidgetConfig();

            this.numPhotos = obj.num_photos;

            var ob = {
                obj: obj,
                event: 'Opened Widget',
                cookieEvent: 'pixlee:create:cookie'
            };
            _this.queueArray.push(ob);

            if (this.pendingWidgetVisible) {
                this.pendingWidgetVisible = false;
                this.numPhotos > 0 && this.WidgetVisible();
            }
        },
        clickUploader: function(step, data) {
            var obj = this.defaultProperties();
            obj.widget = this.widget;
            obj.user_info = this.defaultUserInfo();
            obj.user_info.name = data.name;
            obj.user_info.user_handle = data.user_handle;
            obj.user_info.email = data.email;
            obj.step = step;
            obj.channel = data.channel;
            obj.number_of_media = data.number_of_media;
            obj.header_options = data.header_options;
            obj.widget_type = data.widget_type;
            if (!_.isFalsy(data.nav_to)) {
                obj.nav_to = data.nav_to;
            }
            if (!_.isFalsy(data.nav_from)) {
                obj.nav_from = data.nav_from;
            }
            var ob = {
                obj: obj,
                event: 'Click Uploader',
                cookieEvent: 'pixlee:interacted'
            };
            this.queueArray.push(ob);
        },
        googlePhotosFilterEvent: function(ev, data) {
            var obj = this.defaultProperties();
            var ob = {
                obj: _.extend(obj, data),
                event: ev
            };

            this.queueArray.push(ob);
        },
        interactiveWidgetAnalytics: function(ev, data, cookieEvent) {
            var obj = this.defaultProperties();
            var ob = {
                obj: _.extend(obj, data),
                event: ev
            };
            if (!_.isFalsy(cookieEvent)) {
                ob.cookieEvent = cookieEvent;
            }
            if (ev === 'Click Interactive Bar' || ev === 'Apply Interactive Bar') {
                obj.subcollection = ev;
                //add interacted event!
                var interacted_ob = {
                    obj: _.extend(obj, data),
                    event: 'Interacted'
                };
                this.queueArray.push(interacted_ob);
            } else {
                this.queueArray.push(ob);
            }
        }
    };

    if (_.isFalsy(gon.previewMode)) {
        window.addEventListener('message', function(event) {
            var eventData;
            if (event.data) {
                try {
                    eventData = JSON.parse(event.data);
                } catch (error) {
                    // Some other way of sending data, ignore
                    return;
                }
            } else {
                return;
            }

            if (eventData.name) {
                if (eventData.name === 'pixlee:fingerprint') {
                    gon.fingerprint = eventData.data;
                    API.queueEvents();
                } else if (eventData.name === 'pixlee:cookie') {
                    API.acceptCookiePolicy = eventData.data;
                    gon.acceptCookiePolicy = eventData.data;
                }
            }
        }.bind(this));

        var getFingerprintMessage = {
            name: 'pixlee:get:fingerprint:from:parent',
            type: 'action',
            destination: 'all',
            source: '',
            data: {}
        }

        var getCookieMessage = {
            name: 'pixlee:get:cookie:from:parent',
            type: 'action',
            destination: 'all',
            source: '',
            data: {}
        }

        window.parent.postMessage(JSON.stringify(getFingerprintMessage), '*');
        window.parent.postMessage(JSON.stringify(getCookieMessage), '*');
    }
    App.commands.setHandlers({
        'widget:visible': function() {
            if (API.numPhotos === null) {
                API.pendingWidgetVisible = true;
            } else if (API.numPhotos > 0) {
                API.WidgetVisible();
            }
        },
        'opened:single': function(photo) {
            API.OpenedSingle(photo);
        },
        'opened:photowall': function(photos, mosiac) {
            API.OpenedPhotowall(photos, mosiac);
        },
        'opened:tap2shop': function(photos) {
            API.OpenedTap2Shop(photos);
        },
        'opened:carousel': function(rel, collection, options) {
            var photos = _.isEmpty(rel) ? [] : API.getCurrentItemIds(rel, collection);
            API.OpenedCarousel(photos, options);
        },
        'opened:horizontal': function(rel, collection, coverflow) {
            var photos = _.isEmpty(rel) ? [] : API.getCurrentItemIds(rel, collection);
            API.OpenedHorizontal(photos, coverflow);
        },
        'opened:slideshow': function(rel, collection) {
            var photos = API.getCurrentItemIds(rel, collection);
            API.OpenedSlideshow(photos);
        },
        'opened:vertical': function(rel, collection) {
            var photos = _.isEmpty(rel) ? [] : API.getCurrentItemIds(rel, collection);
            API.OpenedVertical(photos);
        },
        'load:more': function(photos, mosiac) {
            API.LoadMore(photos);
        },
        'action:clicked': function(album_photo_id, action_link_url) {
            API.ActionLinkClicked(album_photo_id, action_link_url);
        },
        'opened:photo': function(album_photo_id, current_page, direct_link) {
            API.OpenedPhoto(album_photo_id, current_page, direct_link);
        },
        'nav:left': function(rel, collection) {
            var photos = API.getCurrentItemIds(rel, collection);
            API.NavLeft(photos);
        },
        'nav:right:event': function(rel, collection) {
            var photos = API.getCurrentItemIds(rel, collection);
            API.NavRight(photos);
        },
        'photo:shared': function(album_photo_id, platform) {
            API.PhotoShared(album_photo_id, platform);
        },
        'kpi:event': function(event) {
            API.kpiEvent(event);
        },
        'photo:added': function(data) {
            API.PhotoAdded(data);
        },
        'google:photos:filter:event': function(ev, data) {
            API.googlePhotosFilterEvent(ev, data);
        },
        'standalone:click:through': function(ev) {
            API.StandaloneClickThrough(ev);
        },
        'click:uploader': function(step, data) {
            API.clickUploader(step, data);
        },
        'interactive:widget:analytics': function(ev, data, cookieEvent) {
            API.interactiveWidgetAnalytics(ev, data, cookieEvent);
        }
    });
});
